// extracted by mini-css-extract-plugin
module.exports = {"subHero":"pricing-module--sub-hero--1wqQl","leadCopy":"pricing-module--lead-copy--2GaF1"};